import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedRoutingModule } from './shared-routing.module';
import { FilterComponent } from './components/filter/filter.component';
import { NominationFilterComponent } from './components/nomination-filter/nomination-filter.component';
import { CustomDialogComponent } from './components/custom-dialog/custom-dialog.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { AppSpinnerComponent } from './components/app-spinner/app-spinner.component';
import { AppErrorComponent } from './components/app-error/app-error.component';
import { NameCharactersDirective } from './directives/name-characters.directive';
import { EmpidCharactersDirective } from './directives/empid-characters.directive';
import { NoRecordComponent } from './components/no-record/no-record.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

@NgModule({
  declarations: [
    CustomDialogComponent,
    FilterComponent,
    NominationFilterComponent,
    AppSpinnerComponent,
    AppErrorComponent,
    NameCharactersDirective,
    EmpidCharactersDirective,
    NoRecordComponent
  ],
  imports: [
    NgbModule,
    FormsModule,
    CommonModule,
    SharedRoutingModule,
    NgMultiSelectDropDownModule.forRoot()
  ],
  exports: [
    CustomDialogComponent,
    FilterComponent,
    NominationFilterComponent,
    AppSpinnerComponent,
    AppErrorComponent,
    NameCharactersDirective,
    EmpidCharactersDirective,
    NoRecordComponent
  ],
  entryComponents: [
    CustomDialogComponent
  ]
})
export class SharedModule { }
